import QuestionTabHeader from "./QuestionTabHeader";
import QuestionTabMain from "./QuestionTabMain";

const QuestionDatabaseTab = () => {
  return (
    <>
      <QuestionTabHeader />
      <QuestionTabMain/>
    
    </>
  );
};

export default QuestionDatabaseTab;
